module.exports = __webpack_public_path__ + "static/media/Screenshot_1.c1e45687.png";